module.exports = __webpack_public_path__ + "img/check2.f4e00342.svg";